import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IdentificationService {
  private http = inject(HttpClient);

  private baseUrl = `${environment.apiUrl}/identification`;

  createIdentification(data: any) {
    return this.http.post(this.baseUrl, data);
  }

  getAllIdentifications() {
    return this.http.get(this.baseUrl);
  }

  getIdentification(id: string) {
    return this.http.get(`${this.baseUrl}/${id}`);
  }

  updateIdentificationStatus(
    id: string,
    status: string,
  ) {
    return this.http.patch(
      `${this.baseUrl}/${id}/status`,
      { status },
    );
  }
}